module.exports = __webpack_public_path__ + "static/img/Modle.4ff87d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Modle.png
// module id = OrNN
// module chunks = 0